


import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import Filter from '@/library/filter/filter.interface';
import FilterOptionGroup from '@/components/map-filter-option-group/filter-option-group.interface';
import FilterOption from '@/components/map-filter-option-group/filter-option.interface';
import {merge, of, Observable} from 'rxjs';
import {combineAll, map} from 'rxjs/operators';
import {FiltersInRoute} from '@/library/route/filters-in-route';
import {Slugify} from '@/library/seo/slugify';

@Component({})
export default class AppMapFilterOptionGroup extends Vue {

  @Prop()
  public group!: FilterOptionGroup;

  @Emit('init')
  public emitInit(): void {
  }

  public initialised: boolean = false;

  constructor() {
    super();
  }

  public created(): void {
    Vue.nextTick(() => {
      this.applyFilterOptionsFromRoute().subscribe(() => {
        this.initialised = true;
        this.emitInit();
      });
    });
  }

  public toggleOption(option: FilterOption): void {
    this.verifyAndToggleOption(option).subscribe();
  }

  public selectedFilters(): Filter[][] {
    const selectedOptions = this.group.filterOptions.filter(option => option.isSelected);
    let selectedFilters: Filter[][] = [];
    switch (this.group.type) {
      case 'AND':
        selectedFilters = selectedOptions.map(option => [option.filter(option.name, option.value)]);
        break;
      case 'OR':
        selectedFilters = [selectedOptions.map(option => option.filter(option.name, option.value))];
        break;
    }
    return selectedFilters.filter(filter => filter.length);
  }

  public resetFilter(): void {
    this.group.filterOptions = this.group.filterOptions.map((option: FilterOption) => {
      option.isSelected = false;
      return option;
    })
  }

  public optionIndex(option: FilterOption): number {
    return this.group.filterOptions.findIndex(checkOption => checkOption.id === option.id);
  }

  public verifyAndToggleOption(option: FilterOption): Observable<void> {
    const canSelectObservable = (!option.isSelected && option.canSelect)
        ? option.canSelect(option)
        : of(true);
    return canSelectObservable.pipe(
        map((canSelect: boolean) => {
          const index = this.optionIndex(option);
          const optionFromOptionsList = this.group.filterOptions[index];
          if (optionFromOptionsList) {
            if (canSelect) {
              this.group.filterOptions[index].isSelected = !optionFromOptionsList.isSelected;
            }
            if (optionFromOptionsList.isSelected && optionFromOptionsList.afterSelect) {
              optionFromOptionsList.afterSelect(this.group.filterOptions[index]);
            }
          }
        })
    );
  }

  private applyFilterOptionsFromRoute(): Observable<void> {
    const observables = this.filterOptionsFromRoute().map(filterOption => this.verifyAndToggleOption(filterOption));
    return (observables.length > 0 ? merge(observables).pipe(combineAll()) : of([])).pipe(map(() => {}));
  }

  private filterOptionsFromRoute(): FilterOption[] {
    const filterSlugs: string[] = new FiltersInRoute().value();
    const slugify = new Slugify();
    return this.group.filterOptions
        .filter((option: FilterOption) => {
          const optionSlug = slugify.phrase(option.label);
          return filterSlugs.some((slug: string) => slug === optionSlug);
        });
  }
}
